import { FormInstance } from "antd";
import { AxiosError } from "axios";
import { useCallback } from "react";
import { useMutation, useQuery } from "react-query";
import { getTahseelBannerDetails, patchTahseelBannerDismissStatus } from "api/commercial_document";
import { postTahseelForm } from "api/tahseel";
import { CommercialDocumentName } from "types/CommercialDocument";
import { TahseelFormData, UploadedFile, UrlParams } from "types/tahseel";
import { useIntegrationMixpanelEvent } from "./useMixpanel";

export const useTahseelQueries = ({ document_name }: { document_name: CommercialDocumentName }) => {
  const tahseelBannerQuery = useQuery({
    queryKey: ["tahseelBanner"],
    queryFn: getTahseelBannerDetails,
    enabled: document_name === CommercialDocumentName.INVOICE,
  });

  const dismissTahseelBannerMutation = useMutation({
    mutationKey: ["dismissTahseelBanner", document_name],
    mutationFn: patchTahseelBannerDismissStatus,
  });

  return { tahseelBanner: tahseelBannerQuery.data, dismissTahseelBannerMutation };
};

export const useTahseelFormSubmit = ({ form, open }: { form: FormInstance, open: boolean }) => {
  const { triggerMixpanelEvent } = useIntegrationMixpanelEvent({
    shouldFetchSubscriptionDetails: open,
  });

  const { data, mutate, isLoading, isSuccess, isError } = useMutation<
    UrlParams,
    AxiosError,
    FormData
  >({
    mutationKey: ["postTahseelForm"],
    mutationFn: postTahseelForm,
  });

  const handleSubmit = useCallback(() => {
    const formData: FormData = new FormData();
    const fields = form.getFieldsValue(true) as TahseelFormData;

    (Object.keys(fields) as (keyof TahseelFormData)[]).forEach((key) => {
      const value = fields[key];
      if (Array.isArray(value) && value[0]) {
        const file: UploadedFile = value[0];
        if (file.originFileObj instanceof File) {
          formData.append(key, file.originFileObj);
        }
      } else {
        formData.append(key, value as string);
      }
    });

    triggerMixpanelEvent("AR_Tahseel_Activate");
    mutate(formData);
  }, [form, mutate]);

  return { data, handleSubmit, isLoading, isSuccess, isError };
};
